/**
 * Desteklenen dosya türleri enum
 */
export enum AllowedFileType {
  // Görsel formatları
  JPG = "JPG",
  JPEG = "JPEG",
  PNG = "PNG",
  GIF = "GIF",
  WEBP = "WEBP",
  SVG = "SVG",
  BMP = "BMP",

  // Belge formatları
  PDF = "PDF",
  DOC = "DOC",
  DOCX = "DOCX",
  XLS = "XLS",
  XLSX = "XLSX",
}

/**
 * Ön tanımlı dosya türü grupları
 */
export const ALLOWED_FILE_TYPE_PRESETS = {
  /** Görsel dosyaları (JPG, PNG, GIF, vb.) */
  IMAGE: [
    AllowedFileType.JPG,
    AllowedFileType.JPEG,
    AllowedFileType.PNG,
    AllowedFileType.GIF,
    AllowedFileType.WEBP,
    AllowedFileType.SVG,
    AllowedFileType.BMP,
  ] as AllowedFileType[],

  /** Belge dosyaları (PDF, DOC, XLS, vb.) */
  DOCUMENT: [
    AllowedFileType.PDF,
    AllowedFileType.DOC,
    AllowedFileType.DOCX,
    AllowedFileType.XLS,
    AllowedFileType.XLSX,
  ] as AllowedFileType[],

  /** Tüm desteklenen formatlar */
  ALL: Object.values(AllowedFileType) as AllowedFileType[],
} as const;
